import React from 'react';

import { Route, RouteComponentProps, Switch } from 'react-router';

import LazyComponent from '@fd/ui/LazyComponent';

import { lazyWithRetry } from '../../../helpers/utilities';
import ErrorBoundary from '../../../layouts/Portal/ErrorBoundary';

const CreateModifierGroup = lazyWithRetry(() => import('./pages/CreateModifierGroup'));
const ModifierGroupEdit = lazyWithRetry(() => import('./pages/ModifierGroupEdit'));
const ModifierGroups = lazyWithRetry(() => import('./pages/ModifierGroups'));

type Props = RouteComponentProps;

const ModifierGroupRoutes: React.FC<React.PropsWithChildren<Props>> = (props: Props) => {
  const {
    match: { path },
  } = props;

  return (
    <ErrorBoundary identifier="modifier-group">
      <Switch>
        <Route
          exact
          path={`${path}`}
          render={() => (
            <LazyComponent>
              <ModifierGroups />
            </LazyComponent>
          )}
        />
        <Route
          exact
          path={`${path}/create-modifier-group`}
          render={(routeProps) => (
            <LazyComponent>
              <CreateModifierGroup {...routeProps} />
            </LazyComponent>
          )}
        />
        <Route
          exact
          path={`${path}/:modifierGroupId`}
          render={(routeProps) => (
            <LazyComponent>
              <ModifierGroupEdit {...routeProps} />
            </LazyComponent>
          )}
        />
      </Switch>
    </ErrorBoundary>
  );
};

export default ModifierGroupRoutes;
